import { CommonModule } from '@angular/common';
import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { BaseComponent } from '@app/core/bases';
import { WidgetService } from '@app/core/services';
import { ButtonModule } from 'primeng/button';
import { CardModule } from 'primeng/card';
import { ChartModule } from 'primeng/chart';

@Component({
  selector: 'app-dashboard',
  imports: [CommonModule, ButtonModule, CardModule, ChartModule],
  templateUrl: './dashboard.component.html',
})
export class DashboardComponent extends BaseComponent implements OnInit {
  nbReferences!: number
  nbStocks!: number

  chartEtatData: any;
  chartEtatOptions: any;

  chartSecteurData: any;
  chartSecteurOptions: any;

  isLoadingData: boolean = false;

  constructor(private widgetService: WidgetService, private cd: ChangeDetectorRef) {
    super();
  }

  ngOnInit(): void {
    this.getWidgetsData()
  }

  getWidgetsData(): void {
    this.widgetService.getNbReferences().subscribe((data: any) => this.nbReferences = data.nb_references)
    this.widgetService.getNbStocks().subscribe((data: any) => this.nbStocks = data.nb_stocks)
    this.widgetService.getRepartitionEtat().subscribe((data: any) => this.initChartEtat(data))
    this.widgetService.getRepartitionSecteur().subscribe((data: any) => this.initChartSecteur(data))
  }

  initChartEtat(data: any): void {
    const documentStyle = getComputedStyle(document.documentElement);
    const textColor = documentStyle.getPropertyValue('--p-text-muted-color');

    this.chartEtatData = {
      labels: Object.keys(data),
      datasets: [
        {
          data: Object.values(data),
          backgroundColor: [
            documentStyle.getPropertyValue('--p-green-500'),
            documentStyle.getPropertyValue('--p-blue-500'),
            documentStyle.getPropertyValue('--p-orange-500'),
            documentStyle.getPropertyValue('--p-red-500'),
          ],
          hoverBackgroundColor: [
            documentStyle.getPropertyValue('--p-green-400'),
            documentStyle.getPropertyValue('--p-blue-400'),
            documentStyle.getPropertyValue('--p-orange-400'),
            documentStyle.getPropertyValue('--p-red-400'),
          ]
        }
      ]
    };

    this.chartEtatOptions = {
      plugins: {
        legend: {
          labels: {
            usePointStyle: true,
            color: textColor
          }
        }
      }
    };

    this.cd.markForCheck()
  }

  initChartSecteur(data: any): void {
    const documentStyle = getComputedStyle(document.documentElement);
    const textColor = documentStyle.getPropertyValue('--p-text-muted-color');
    const bgColors: string[] = []
    const hoverBgColors: string[] = []

    Object.keys(data).forEach(secteur => {
      bgColors.push(this.getSectorColor(documentStyle, secteur, false))
      hoverBgColors.push(this.getSectorColor(documentStyle, secteur, true))
    })

    this.chartSecteurData = {
      labels: Object.keys(data),
      datasets: [
        {
          label: 'Stocks',
          data: Object.values(data),
          backgroundColor: bgColors,
          hoverBackgroundColor: hoverBgColors
        }
      ]
    };

    this.chartSecteurOptions = {
      maintainAspectRatio: false,
      plugins: {
        legend: {
          display: false,
          labels: {
            usePointStyle: true,
            color: textColor
          }
        }
      },
      scales: {
        y: {
          stacked: true,
          grid: {
            display: true,
            color: textColor
          }
        },
        x: {
          grid: {
            display: false
          }
        }
      }
    };

    this.cd.markForCheck()
  }

  getSectorColor(documentStyle: CSSStyleDeclaration, secteur: string, hover: boolean): string {
    switch (secteur) {
      case 'BLEU': return hover ? documentStyle.getPropertyValue('--p-blue-400') : documentStyle.getPropertyValue('--p-blue-500');
      case 'GRIS': return hover ? documentStyle.getPropertyValue('--p-gray-300') : documentStyle.getPropertyValue('--p-gray-400');
      case 'JAUNE': return hover ? documentStyle.getPropertyValue('--p-yellow-400') : documentStyle.getPropertyValue('--p-yellow-500');
      case 'NOIR': return hover ? documentStyle.getPropertyValue('--p-gray-500') : documentStyle.getPropertyValue('--p-gray-600');
      case 'ROUGE': return hover ? documentStyle.getPropertyValue('--p-red-400') : documentStyle.getPropertyValue('--p-red-500');
      case 'VERT': return hover ? documentStyle.getPropertyValue('--p-green-400') : documentStyle.getPropertyValue('--p-green-500');
      default: return documentStyle.getPropertyValue('--p-gray-500');
    }
  }
}
